import type * as React from "react";

import { cn } from "../lib/cn";

export interface SettingsCardProps extends Omit<
  React.HTMLAttributes<HTMLElement>,
  "title" | "children"
> {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  children?: React.ReactNode;
  ref?: React.Ref<HTMLElement>;
}

/** Stack siblings with `gap-6`. */
export function SettingsCard({
  title,
  subtitle,
  children,
  className,
  ...rest
}: SettingsCardProps) {
  return (
    <section
      {...rest}
      className={cn(
        "min-w-0 border-t border-rule pt-6 font-body first:border-t-0 first:pt-0",
        className,
      )}
    >
      <h2 className="font-display text-base font-medium text-ink">{title}</h2>
      {subtitle != null && (
        <p className="mt-1 max-w-2xl text-sm text-annotation">{subtitle}</p>
      )}
      {children != null && <div className="mt-4 max-w-3xl">{children}</div>}
    </section>
  );
}
